import map from "rfuncs/functions/map"
import scan from "rfuncs/functions/scan"

import selector from "./selector"

export default (
  el: Element | Element[] | string,
  classes: Record<string, boolean>
): Element[] => {
  return map(e => {
    scan(
      (check, clist) =>
        scan(
          c => e.classList[check ? "add" : "remove"](c),

          clist ? clist.split(" ") : []
        ),

      classes
    )
    return e
  }, selector(el))
}
